import type { JiraSideNav } from '@post-office/placement-create-pipeline/pipes';

import { createClientPipeline } from '@post-office/placement-create-pipeline/create-pipeline';

import { type MessageTemplateContext } from '../../..';

import { type JSX } from 'react/jsx-runtime';

import type {
	HydrationResult as HydrationResultShape,
	AdditionalProps,
} from '@post-office/browser--puma/common/in-app/cjn-nav4/types';

export type HydrationResult = HydrationResultShape;

export type RenderProps = HydrationResult & AdditionalProps;

type Pipe = JiraSideNav<{
	messageContext: MessageTemplateContext;
	hydrationResult: HydrationResult;
}>;

const clientPipeline = createClientPipeline<Pipe>();

export const createRender: <U extends (renderProps: RenderProps) => JSX.Element | null>(
	render: U,
) => (renderProps: RenderProps) => JSX.Element | null = clientPipeline.createRender;
